/**
 * Custom JS
 */
jQuery(document).ready(function($) {
  $('.mobile-nav-panel .navmenu-back').on('click', function(e) {
    $(this).parent('.navmenu-inner').parent('.navmenu').removeClass('show');
    $(this).parent('.navmenu-inner').parent('.navmenu').parent().parent().parent('div.navmenu').removeClass('hidden');
    $(this).parent('.navmenu-inner').parent('.navmenu').parent().parent().parent('div.navmenu-submenu').addClass('show');
  });

  $('.mobile-nav-panel .navmenu-button').on('click', function(e) {
    $(this).parent().parent().parent('div.navmenu').removeClass('show').addClass('hidden');
    $(this).next('div.navmenu').addClass('show');
  });

  $('.collection-modal-head > div a').on('click', function(e) {
    e.preventDefault();

    $('.collection-modal-head > div').removeClass('active');
    $(this).parent().addClass('active');

    if ( $(this).parent().hasClass('size-filter') ) {
      $('.product-collection-modal .groups-filter-style-wrap .sizes-style').css('height', 'auto');
      $('.product-collection-modal .groups-filter-style-wrap').addClass('sizes-active');
      $('.product-collection-modal .groups-filter-style-wrap .others-style').delay(300).queue(function (next) { 
        $(this).css('height', '1px');
        next(); 
      });
    } else {
      $('.product-collection-modal .groups-filter-style-wrap .others-style').css('height', 'auto');
      $('.product-collection-modal .groups-filter-style-wrap').removeClass('sizes-active');
      $('.product-collection-modal .groups-filter-style-wrap .sizes-style').delay(300).queue(function (next) { 
        $(this).css('height', '1px');
        next(); 
      });
    }
  });

  // reset ative tab

  var sizeFilter = $('.groups-filter-style-wrap .sizes-style').length;
  if ( sizeFilter == 0 ) {
    $('.collection-modal-head').addClass('size-disabled');
  } else {
    $('.collection-modal-head').removeClass('size-disabled');
  }

  $(document).ajaxComplete(function() {
    var sizeFilter = $('.groups-filter-style-wrap .sizes-style').length;
    if ( sizeFilter == 0 ) {
      $('.collection-modal-head').addClass('size-disabled');
    } else {
      $('.collection-modal-head').removeClass('size-disabled');
    }
  });

  $('.site-header-menu-button').on('click', function(e) {
    $('.mobile-nav-outclose').addClass('visible');
  });

  $('.mobile-nav-overlay').on('click', function(e) {
    $('.mobile-nav-outclose').removeClass('visible');
  });

  $('.mobile-nav-outclose').on('click', function(e) {
    $(this).removeClass('visible');
    $('.mobile-nav-panel .mobile-nav-close').click();
  });

  $('.store-grid-container .mobile-title').each(function() {
    var $this = $(this);

    $this.on('click', function(e) {
      $this.toggleClass('active');
      $this.parent('.single-store').toggleClass('active');
      $this.next('.store-content').slideToggle(250);
    });
  });

  $('.store-grid-container .store-img').each(function() {
    var $this = $(this);

    $this.on('click', function(e) {
      if ( $(window).width() < 1080 ) {
        $this.parent('.single-store').toggleClass('active');
        $this.next().next('.store-content').slideToggle(250);
      }
    });
  });

  $('.product-recently-viewed--content').on( 'select.flickity change.flickity', function() {
    var highestHeight = 100;

  //  $('.product-recently-viewed-card').css('height', 'auto');

    setTimeout(function(e) {
      $('.product-recently-viewed-card').each(function() {
        highestHeight = Math.max(highestHeight, $(this).height());
      });

      $('.product-recently-viewed-card').css('height', highestHeight + 'px');
    }, 400);
  });




  $('.product-related--content').on( 'select.flickity change.flickity', function() {
    var highestHeight = 100;

  //  $('.product-recently-viewed-card').css('height', 'auto');

    // setTimeout(function(e) {
    //   $('.product-related--content .productgrid--item').each(function() {
    //     highestHeight = Math.max(highestHeight, $(this).height());
    //   });

    //   $('.product-related--content .productgrid--item').css('height', highestHeight + 'px');
    // }, 400);
  });


  $('body').on('click', '.utils-filter-button', function() {
    $('.brand-filter').addClass('active');
    $('.size-filter').removeClass('active');

  });
  
  // search functions
  $('body').on('click', '[data-search-toggle-new]', function() {
        $(".live-search").toggleClass("active");
  });
  
  
  
  
});



(function() {
  var touchingCarousel = false,
      touchStartCoords;

  document.body.addEventListener('touchstart', function(e) {
    if (e.target.closest('.flickity-slider')) {
      touchingCarousel = true;
    } else {
      touchingCarousel = false;
      return;
    }

    touchStartCoords = {
      x: e.touches[0].pageX,
      y: e.touches[0].pageY
    }
  });

  document.body.addEventListener('touchmove', function(e) {
    if (!(touchingCarousel && e.cancelable)) {
      return;
    }

    var moveVector = {
      x: e.touches[0].pageX - touchStartCoords.x,
      y: e.touches[0].pageY - touchStartCoords.y
    };

    if (Math.abs(moveVector.x) > 7)
      e.preventDefault()

      }, {passive: false});
})();





/*
// newsletter error messages
$(function(){
  $('.new_newsletter_input').on('input',function(e){
    $(".new_newsletter_error").show();
    $(".new_newsletter_input").css("border-color", "#c00");
  });
  $('.new_newsletter_input').bind('input propertychange', function() {
    if ($(this).val().indexOf('@') > -1) {
      $(".new_newsletter_input").css("border-color", "#000");
      $(".new_newsletter_button").show();
      $(".new_newsletter_error").hide();
    }
  });
  $(document).mouseup(function(e) {
      var container = $("#newsletter_deskr");
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.hide();
      }
    });
  $(".newsletter_pop").click(function(){
    $("#newsletter_deskr").show();
    $(".new_newsletter_button").show();
  });
  
});
*/

$(function(){
  $(".newsletter_pop").click(function(){
    $("#newsletter_deskr").show();
    $(".new_newsletter_button").show();
  });
  $(document).mouseup(function(e) {
      var container = $("#newsletter_deskr");
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.hide();
      }
    });
});

// product buttons disabled before select
$(function(){
  if ($('[data-product-option]').length > 0) {
    // select first option
	$("option[data-first='true']").prop("selected", true);
    setTimeout(function(){
      $("option[data-first='true']").prop("selected", true);
    }, 200);
    setTimeout(function(){
      $("option[data-first='true']").prop("selected", true);
    }, 500);
    setTimeout(function(){
      $("option[data-first='true']").prop("selected", true);
    }, 1000);
    // disable em buttons if we have to force selection
    //$('.product-form--atc-button').attr('disabled','disabled');
    //setTimeout(function(){
      //$('.product-form--atc-button').addClass('disabled_btn');
      //$('.shopify-payment-button .shopify-payment-button__button--unbranded').addClass('disabled_btn');
    //}, 1400);
    
    $(".pseudo_buy").on('click', function (e) {
      $("#select_a_size").show();
    });

    $('[data-product-option]').on('change', function() {
      $('.product-form--atc-button').removeAttr('disabled');
      $("option[data-first='true']").remove();
      $(".pseudo_buttons").hide();
      $("#select_a_size").hide();
      $(".add_wrapper").show();
      
      var value = $(this).val();
	 //$('option[value="' + value +'"]').prop("selected", true);
    });
  }
});

$(document).ready(function() {
    setTimeout(function(){
      $('option[data-available="unavailable"]').attr("disabled", "disabled");
    }, 500);
});

jQuery(document).ready(function($) {
var is_promo_2_closed = Cookies.get('promo_2_closed');
if (is_promo_2_closed == "true") {
  $(".announcement-bar-2").css('display', 'none');
} else {
  $(".announcement-bar-2").css('display', 'block');
  $(".announcement-bar-2").css('min-height', '44px');
  $(".promo-block-inner").css('min-height', '44px');
  
}
// closing of promo - hide and set cookie
$(".announcement-close-2").click(function(){
   $(".announcement-bar-2").css('display', 'none');
   Cookies.set('promo_2_closed', 'true');
});
});

// oct 2023
jQuery(document).ready(function($) {
var header_height = $(".sticky_header_wrapper").outerHeight();
var adjusted_header_height = header_height + 0;
var adjusted_header_height_2 = header_height + 30;
$("#site-main").css("padding-top", adjusted_header_height +"px");  
$(".product-collection-modal .modal-inner").css("padding-top", "30px !Important");
$(".product-collection-modal").css("top", header_height +"px");  
});


// updates for currency picker
$('.currency-converter-wrapper .current').html('EUR');

jQuery(document).ready(function(){
    var location_by_cookie = Cookies.get('api_location');
    var has_closed_currency_modal = Cookies.get('has_closed_currency_modal');

    if(jQuery.type(location_by_cookie) === "undefined"){
      // we need to use api to get location and then save

      jQuery.ajax( {
        url: 'https://api.ipstack.com/check?access_key=022f07ff4126103094b520857c97fd57&output=json&legacy=1',
        type: 'POST',
        dataType: 'jsonp',
        success: function(location) {


          // get the location country
          var countryLocation = (location.country_code);
          var continent_name = (location);

          
          // set location as cookie to speed things up and reduce api calls
          Cookies.set('api_location', countryLocation, { expires: 1 })

          var eu_countries = ['AT', 'DE', 'RS', 'VA', 'UA', 'SE', 'ES', 'SI', 'SK', 'RS', 'SM', 'RU', 'RO', 'PT', 'PL', 'NO', 'NL', 'ME', 'MC', 'MD', 'MT', 'MK', 'LU', 'LT', 'LI', 'LV', 'RS', 'IT', 'IM', 'IE', 'IS', 'HU', 'GR', 'GI', 'FR', 'FI', 'FO', 'EE', 'DK', 'CZ', 'CY', 'HR', 'BG', 'BA', 'BE', 'BY', 'AD', 'AL'];
          var de_countries = ['AT', 'DE'];
          var country_code = location.country_code;

          if(jQuery.inArray(country_code, eu_countries) != -1) {
              $('#select_currency').val('EUR').trigger('change');
              $('.currency-converter-wrapper .current').html('EUR');
            
            // FOR USE OF MODAL
            //if(jQuery.type(has_closed_currency_modal) === "undefined"){
              //$('#select_currency').val('EUR').trigger('change');
              //$('.currency-converter-wrapper .current').html('EUR');
              //$( ".currency-modal" ).addClass( "is-active" );
              //console.log("is in eu array" + "country" + country_code);
              //}
              
          }

          if(country_code == 'US') {
            $('#select_currency').val('USD').trigger('change');
            $('.currency-converter-wrapper .current').html('USD');
          }
          
          if(country_code == 'GB') {
            $('#select_currency').val('GBP').trigger('change'); 
            $('.currency-converter-wrapper .current').html('GBP');
          }

          if(country_code == 'CA') {
            $('#select_currency').val('CAD').trigger('change'); 
            $('.currency-converter-wrapper .current').html('CAD');
          }

          if(country_code == 'CH') {
            $('#select_currency').val('CHF').trigger('change');
            $('.currency-converter-wrapper .current').html('CHF');
          }

          if(country_code == 'NO') {
            $('#select_currency').val('NOK').trigger('change');
            $('.currency-converter-wrapper .current').html('NOK');
          }
          
          if(country_code == 'AU') {
            $('#select_currency').val('AUD').trigger('change');
            $('.currency-converter-wrapper .current').html('AUD'); 
          }

          if(country_code == 'NZ') {
            $('#select_currency').val('NZD').trigger('change');
            $('.currency-converter-wrapper .current').html('NZD');
          }

          if(country_code == 'JP') {
            $('#select_currency').val('JPY').trigger('change'); 
            $('.currency-converter-wrapper .current').html('JPY');
          }

          if(country_code == 'KR') {
            $('#select_currency').val('KRW').trigger('change');
            $('.currency-converter-wrapper .current').html('KRW');
          }
          
        }
      });




    } else {
      // we have a cookie for location so let's use that
      
      var eu_countries = ['AT', 'DE', 'RS', 'VA', 'UA', 'CH', 'SE', 'ES', 'SI', 'SK', 'RS', 'SM', 'RU', 'RO', 'PT', 'PL', 'NO', 'NL', 'ME', 'MC', 'MD', 'MT', 'MK', 'LU', 'LT', 'LI', 'LV', 'RS', 'IT', 'IM', 'IE', 'IS', 'HU', 'GR', 'GI', 'FR', 'FI', 'FO', 'EE', 'DK', 'CZ', 'CY', 'HR', 'BG', 'BA', 'BE', 'BY', 'AD', 'AL'];
      var de_countries = ['AT', 'DE'];
      // grab stored cookie
      var country_code = location_by_cookie;
      
      //yeah this should prob be in a function but whatevs
      if(jQuery.inArray(country_code, eu_countries) != -1) {
        
            $('#select_currency').val('EUR').trigger('change');
            //console.log("is in eu array" + "country " + country_code);
          }

          if(country_code == 'US') {
            $('#select_currency').val('USD').trigger('change');
          }

          if(country_code == 'IN') {
            $('#select_currency').val('INR').trigger('change'); 
          }

          if(country_code == 'GB') {
            $('#select_currency').val('GBP').trigger('change'); 
          }

          if(country_code == 'CA') {
            $('#select_currency').val('CAD').trigger('change'); 
          }

          if(country_code == 'AU') {
            $('#select_currency').val('AUD').trigger('change'); 
          }

          if(country_code == 'JP') {
            $('#select_currency').val('JPY').trigger('change'); 
          }
		
      	  // hide for non lithuania the lang picker
          if(country_code == 'LT') { 
            if ($(window).width() < 768) {
              $( "#mob_lang" ).show(); 
            } else {
              $( "#desktop_lang" ).show();  
            }
          }
      
    }

  // trigger modal close
    function CurrencyModalCloseFunction() {
     $( ".currency-modal" ).removeClass( "is-active" );
    Cookies.set('has_closed_currency_modal', true, { expires: 1 })
    };

  // modal close actions
  $(".currency-modal-close_action").click(CurrencyModalCloseFunction);

  // hacks due to nice select
  var currency_stored = localStorage.getItem('currency');
  $('.currency-converter-wrapper .current').html(currency_stored);
  

  $('#select_currency_2').on('change', function() {
      var currency_chosen = $('#select_currency_2').val();
      $('.currency-converter-wrapper .current').html(currency_chosen);
    });

  

  });  

